export const APP_BAR_HEIGHT = 64
export const DRAWER_WIDTH = 240
export const CLOSED_DRAWER_WIDTH = 72
export const SIDEBAR_NAVIGATION_WIDTH = 270

export const FULL_MODAL_PLAN_SUB_ENTITY_WIDTH = 480

export const LAYOUT_CONTAINER_WIDTH = {
  EXPANDED: 426,
  COLLAPSED: 530
}
